<div class="p-top-153 p-b-20 height_100_per sidebar" [ngClass]="toggle_sidebar ? 'width_80' : 'default_width'">
  <div class="sidebar_top" style="position: relative; display: flex; justify-content: flex-end;">
    <div
      class="dis_flex jc_center align_center bg_1 width_32 height_32 border-radius-50-per shadow_effect_1 cursor_pointer"
      style="transform: translateX(50%);"
      (click)="toggleSidebar()">
      <img *ngIf="!toggle_sidebar" src="../../../assets/icons/rightclose.png" />
      <img *ngIf="toggle_sidebar" src="../../../assets/icons/rightopen.png" />
    </div>
  </div>
  <div class="sidebar_bottom">
    <ng-container *ngFor="let menu of menu_list; let i = index">
      <!-- For opened sidebar -->
      <div *ngIf="!toggle_sidebar">
        <a *ngIf="menu.route === 'inside'" [routerLink]="menu.link" class="sidebar-link"
          [ngClass]="selected_menu_index === i ? 'bg_2' : 'bg_1'" (click)="select_menu(i)">
          <div class="menu-item">
            <img *ngIf="i !== selected_menu_index" [src]="icon_base_url + menu.logo" class="menu-icon" />
            <img *ngIf="i === selected_menu_index" [src]="icon_base_url + menu.selected_logo" class="menu-icon" />
            <span class="menu-text" [ngClass]="i === selected_menu_index ? 'color_blue' : 'color_black'">{{ menu.title
              }}</span>
          </div>
        </a>

        <a *ngIf="menu.route === 'outside'" target="_blank" [href]="menu.link" class="sidebar-link"
          [ngClass]="i === selected_menu_index ? 'bg_2' : 'bg_1'">
          <div class="menu-item">
            <img *ngIf="i !== selected_menu_index" [src]="icon_base_url + menu.logo" class="menu-icon" />
            <img *ngIf="i === selected_menu_index" [src]="icon_base_url + menu.selected_logo" class="menu-icon" />
            <span class="menu-text" [ngClass]="i === selected_menu_index ? 'color_blue' : 'color_black'">{{ menu.title
              }}</span>
          </div>
        </a>
      </div>

      <!-- For closed sidebar -->
      <div *ngIf="toggle_sidebar">
        <a *ngIf="menu.route === 'inside'" [routerLink]="menu.link" class="sidebar-link center-link"
          [ngClass]="selected_menu_index === i ? 'bg_2' : 'bg_1'" (click)="select_menu(i)">
          <div [pTooltip]="menu.title" tooltipPosition="right">
            <img *ngIf="i !== selected_menu_index" [src]="icon_base_url + menu.logo" class="menu-icon" />
            <img *ngIf="i === selected_menu_index" [src]="icon_base_url + menu.selected_logo" class="menu-icon" />
          </div>
        </a>

        <a *ngIf="menu.route === 'outside'" target="_blank" [href]="menu.link" class="sidebar-link center-link"
          [ngClass]="i === selected_menu_index ? 'bg_2' : 'bg_1'">
          <div [pTooltip]="menu.title" tooltipPosition="right">
            <img *ngIf="i !== selected_menu_index" [src]="icon_base_url + menu.logo" class="menu-icon" />
            <img *ngIf="i === selected_menu_index" [src]="icon_base_url + menu.selected_logo" class="menu-icon" />
          </div>
        </a>
      </div>

    </ng-container>
  </div>
</div>
<div class="sidebar1 p-top-153 p-b-20">
  <div class="sidebar1_body">
    <div (click)="toggleMenuList()" class="cursor_pointer sidebar1_body_hamburger">
      <a><img src="../../../assets/icons/hamburger.png" alt="menu" /></a>
    </div>
    <div class="bg_1">
      <ng-container *ngIf="showMenuList">
        <div *ngFor="let menu of menu_list; let i = index">
          <a *ngIf="menu.route === 'inside'" [routerLink]="menu.link"
            class="cursor_pointer text_decoration_none p-l-28 p-r-10 p-y-16 dis_flex"
            [ngClass]="selected_menu_index === i ? 'bg_2' : 'bg_1'" (click)="select_menu(i); hideMenuList()">
            <div>
              <img [src]="
                  selected_menu_index === i
                    ? icon_base_url + menu.selected_logo
                    : icon_base_url + menu.logo
                " />
            </div>
            <div>
              <span class="p-l-10 font_13 weight_500 dis-flex-2" [ngClass]="
                  selected_menu_index === i ? 'color_blue' : 'color_black'
                ">{{ menu.title }}</span>
            </div>
          </a>
          <a *ngIf="menu.route === 'outside'" target="_blank" [href]="menu.link"
            class="cursor_pointer text_decoration_none p-l-28 p-r-10 p-y-16 dis_flex"
            [ngClass]="selected_menu_index === i ? 'bg_2' : 'bg_1'" (click)="hideMenuList()">
            <div>
              <img [src]="
                  selected_menu_index === i
                    ? icon_base_url + menu.selected_logo
                    : icon_base_url + menu.logo
                " />
            </div>
            <div>
              <span class="p-l-10 font_13 weight_500" [ngClass]="
                  selected_menu_index === i ? 'color_blue' : 'color_black'
                ">{{ menu.title }}</span>
            </div>
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</div>